import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { getStore360Charts } from 'Services/Analytics/saleChannel-analytics'
import BarChartTemplate from 'Pages/Analytics/SaleAnalytics/Components/BarChart.Template'
import BarLineChartTemplate from 'Pages/Analytics/SaleAnalytics/Components/BarLineChart.Template'

const ChartRow3 = () => {
  const { id } = useParams()
  return (
    <>
      <div className="bg-white p-4 col-span-1 shadow-div_b">
        <div className="mb-4 font-semibold">{`Item/Order (Avg)`}</div>
        <div className="w-full overflow-y-scroll overflow-x-hidden" style={{ height: 260 }}>
          <BarLineChartTemplate
            chartCode="item_per_order"
            handleDataFunction={getStore360Charts}
            isHalf
          />
        </div>
      </div>
      <div className="bg-white p-4 col-span-1 shadow-div_b">
        <div className="mb-4 font-semibold">Orders and AOV</div>
        <div className="w-full overflow-y-scroll overflow-x-hidden" style={{ height: 260 }}>
          <BarLineChartTemplate
            chartCode="order_and_aov"
            handleDataFunction={getStore360Charts}
            isHalf
          />
        </div>
      </div>
    </>
  )
}

export default ChartRow3
